const StarsIcon = (): JSX.Element => (
  <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_5703_4029)">
      <path
        d="M31.7277 20.2277C25.2507 20.2277 20 14.977 20 8.5"
        stroke="#E1A613"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M19.9998 32.2277C19.9998 25.7507 25.2505 20.5 31.7275 20.5"
        stroke="#E1A613"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M7.99983 20.4998C14.4769 20.4998 19.7275 25.7505 19.7275 32.2275"
        stroke="#E1A613"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M19.7277 8.49983C19.7277 14.9769 14.477 20.2275 8 20.2275"
        stroke="#E1A613"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M30 30.5L35 35.5"
        stroke="#E1A613"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10.5L5 5.5"
        stroke="#E1A613"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30 10.5L35 5.5"
        stroke="#E1A613"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 30.5L5 35.5"
        stroke="#E1A613"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5703_4029">
        <rect width="40" height="40" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default StarsIcon;
